export const FakeService = [
    {
        "id": "001",
        "title": "Nerve compression",
        "description": "Experience relief from Nerve compression with our specialized treatments.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/dentistry.svg"
    },
    {
        "id": "002",
        "title": "Arthritis",
        "description": "Say goodbye to Arthritis pain with our effective physiotherapy services.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/selant.svg"
    },
    {
        "id": "003",
        "title": "Cerebral Palsy(C.P)",
        "description": "Unlock your potential with our Cerebral Palsy(C.P) physiotherapy treatments.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/dictionary.svg"
    },
    {
        "id": "004",
        "title": "Sciatica",
        "description": "Experience quick relief from Sciatica pain through our physiotherapy interventions.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/implants.svg"
    },
    {
        "id": "005",
        "title": "Tennis Elbow",
        "description": "Reclaim your active lifestyle with our Tennis Elbow physiotherapy solutions.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/oral.svg"
    },
    {
        "id": "006",
        "title": "Spondylitis",
        "description": "Relieve Spondylitis discomfort and improve your posture with our treatments.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/general.svg"
    },
    {
        "id": "007",
        "title": "All Joints Pain",
        "description": "Get back to pain-free living with our expert solutions for All Joints Pain.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/implants.svg"
    },
    {
        "id": "008",
        "title": "Cervical Problems",
        "description": "Experience relief from Cervical Problems and improve your neck health with our therapies.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/oral.svg"
    },
    {
        "id": "009",
        "title": "Paralysis",
        "description": "Regain strength, mobility, and independence with our Paralysis physiotherapy treatments.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/general.svg"
    },
    {
        "id": "010",
        "title": "Swelling & Stiffness",
        "description": "Experience rapid relief from Swelling & Stiffness with our effective solutions.",
        "img": "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/implants.svg"
    },
];